// extracted by mini-css-extract-plugin
export default {"wrap":"DF-z","fullWidth":"EF-z","hideOnDesktop":"FF-z","content":"GF-z","hasOpenedNav":"HF-z","crumbsList":"IF-z","dropdownsWrap":"JF-z"};